module.exports = __webpack_public_path__ + "static/salesforce-dark-blue-3173b5b2441f7687619e6b2ebb5233da.svg";